import { tryParseJSON } from "@eventr/common";
import { useMemo } from "react";
import { RowInfoFiles } from "../subComponents/rowInfoFiles";
interface TransportAttachmentsProps {
  extra_docs?: string;
}

export const TransportAttachments = ({ extra_docs }: TransportAttachmentsProps) => {
  const files = useMemo(() => {
    if (!extra_docs) return [];
    return tryParseJSON(extra_docs, []) as string[];
  }, [extra_docs]);
  if (files && files.length === 0) return null;
  return <RowInfoFiles files={files} />;
};
